var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgExport = function SvgExport(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9995 8.41611V20.9991C10.9995 21.5521 11.4475 21.9991 11.9995 21.9991C12.5525 21.9991 12.9995 21.5521 12.9995 20.9991V8.41611L17.1215 12.5371C17.5125 12.9281 18.1455 12.9281 18.5355 12.5371C18.9265 12.1461 18.9265 11.5141 18.5355 11.1231L12.8785 5.46611C12.8495 5.43711 12.8185 5.41011 12.7875 5.38611C12.6035 5.15111 12.3195 5.00211 11.9995 5.00211C11.6805 5.00211 11.3955 5.15111 11.2125 5.38611C11.1815 5.41011 11.1495 5.43711 11.1215 5.46611L5.46451 11.1231C5.07351 11.5141 5.07351 12.1461 5.46451 12.5371C5.85451 12.9281 6.48751 12.9281 6.87851 12.5371L10.9995 8.41611Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9995 4H2.99951C2.44951 4 1.99951 3.55 1.99951 3C1.99951 2.45 2.44951 2 2.99951 2H20.9995C21.5505 2 21.9995 2.45 21.9995 3C21.9995 3.55 21.5505 4 20.9995 4"
  })));
};
export default SvgExport;